import React from 'react';
import { Link } from 'react-router-dom';

const MSGuidanceCounseling = () => {
  const courses = [
    { code: 'GCS 519', name: 'Professional and Ethical Orientation to Guidance and Counseling', credits: 3 },
    { code: 'GCS 546', name: 'Methods in Guidance and Counseling', credits: 3 },
    { code: 'GCS 544', name: 'Social and Culture Foundations of Guidance and Counseling', credits: 3 },
    { code: 'GCS 543', name: 'Administration of Comprehensive Guidance in Education', credits: 3 },
    { code: 'GCS 527', name: 'Developmental Assessment in Guidance and Counseling', credits: 3 },
    { code: 'GCS 548', name: 'Group Guidance in Guidance and Counseling', credits: 3 },
    { code: 'GCS 528', name: 'Action Research, Data Analysis & Info Resources', credits: 3 },
    { code: 'GCS 529', name: 'Human Development and Learning', credits: 3 },
    { code: 'GCS 549', name: 'Career Development and Assessment', credits: 3 },
    { code: 'GCS 538', name: 'Consultation, Leadership and Advocacy Roles', credits: 3 },
    { code: 'GCS 551', name: 'Supervised Practicum', credits: 9 },
    { code: 'GCS 599', name: 'Comprehensive Examination', credits: 3 }
  ];

  const programFeatures = [
    {
      title: "Professional Development",
      description: "Comprehensive training in modern guidance and counseling methodologies",
      icon: "🎓"
    },
    {
      title: "Practical Experience",
      description: "Extensive supervised practicum opportunities in real educational settings",
      icon: "💼"
    },
    {
      title: "Research Focus",
      description: "Strong emphasis on action research and data-driven decision making",
      icon: "📊"
    },
    {
      title: "Leadership Training",
      description: "Development of consultation and advocacy skills for educational leadership",
      icon: "👥"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl font-bold mb-4">
              Master of Science in School Guidance and Counseling
            </h1>
            <p className="text-xl opacity-90">
              Preparing professional counselors for educational leadership and student support
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Overview Section */}
          <section className="mb-16">
            <div className="bg-white rounded-xl shadow-sm p-8">
              <h2 className="text-2xl font-bold mb-6">Program Overview</h2>
              <div className="prose max-w-none text-gray-600">
                <p className="mb-4">
                  The Master of Science in School Guidance and Counseling program is designed to prepare 
                  professional counselors for leadership roles in educational settings. Our comprehensive 
                  curriculum combines theoretical knowledge with practical experience, ensuring graduates 
                  are well-equipped to support student development and success.
                </p>
                <p>
                  Through a blend of coursework, research, and supervised practice, students develop the 
                  skills needed to provide effective guidance services and advocate for student well-being 
                  in modern educational environments.
                </p>
              </div>
            </div>
          </section>

          {/* Program Features */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Program Features</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {programFeatures.map((feature, index) => (
                <div key={index} className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                  <div className="flex items-start gap-4">
                    <span className="text-3xl">{feature.icon}</span>
                    <div>
                      <h3 className="text-xl font-semibold mb-2 text-primary-600">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Curriculum Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Curriculum</h2>
            <div className="bg-white rounded-xl shadow-sm p-8">
              <div className="space-y-6">
                {courses.map((course, index) => (
                  <div key={index} className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="flex-shrink-0 w-16 h-16 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center text-sm font-medium">
                      {course.credits} CR
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{course.code}</h3>
                      <p className="text-gray-600">{course.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section>
            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">Begin Your Journey in Educational Counseling</h2>
              <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                Take the first step towards becoming a professional school counselor and making a 
                difference in students' lives.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link
                  to="/application"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-200"
                >
                  Apply Now
                </Link>
                <Link
                  to="/request"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-primary-700 bg-white border border-primary-200 hover:bg-primary-50 transition-colors duration-200"
                >
                  Request Information
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MSGuidanceCounseling; 